import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatInputModule } from '@angular/material/input';
//------------------- XXXXXX Default components XXXXXXXX ---------------------
import { DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatRadioModule } from '@angular/material/radio';
/* Static Page Components */
import { HomeComponent } from './home/home.component';
import { DialogsContentDialogComponent } from './home/home.component';
import { DialogHiringsDialogComponent } from './corporate-hirings/corporate-hirings.component';

import { SelectProgramComponent } from './home/home.component';
// import{popupOverviewExamplepopup} from './home/home.component';
/* Material Components */
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';

/* Other stand-alone Angular components */
import { FlexLayoutModule } from '@angular/flex-layout';
import { SiteFooterComponent } from './_components/site-footer/site-footer.component';
import { SiteNavComponent } from './_components/site-nav/site-nav.component';
import { SiteNavInnerComponent } from './_components/site-nav/site-nav.component';
import { MatSelectModule } from '@angular/material/select';

import {
  SocialLoginModule,
  AuthServiceConfig,
  GoogleLoginProvider,
  FacebookLoginProvider,
  LoginOpt,
} from 'angularx-social-login';
import { environment } from '../environments/environment';

import { GoogleAnalyticsService } from './_services/analytics/google-analytics.service';
// import { MatNavListModule } from '@angular/material/menu';
import { CommonInterceptor } from './_interceptor/common.interceptor';
import { LogoutInterceptor } from './_interceptor/logout.interceptor';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
// import {MatListModule} from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { ResumeDialogComponent } from './_modules/shared/resume-builder/resume-dialog/resume-dialog.component';
const fbLoginOptions: LoginOpt = {
  scope: 'email',
  auth_type: 'rerequest',
  return_scopes: true,
  enable_profile_selector: true,
  offline_access: false,
};

let config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(environment.googleClientId),
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider(
      environment.facebookClientId,
      fbLoginOptions
    ),
  },
]);

export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    SiteFooterComponent,
    SiteNavComponent,
    SiteNavInnerComponent,
    DialogsContentDialogComponent,
    SelectProgramComponent,
    DialogHiringsDialogComponent,
   
  
   
  

    // popupOverviewExamplepopup,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    MatBottomSheetModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatTabsModule,
    MatExpansionModule,

    /* Material Components */
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatDividerModule,

    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    MatTooltipModule,
    MatBadgeModule,
    MatSnackBarModule,
    MatInputModule,

    MatRadioModule,
    /* Other stand-alone Angular components */
    FlexLayoutModule,
    SocialLoginModule,

    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatSelectModule,
    MatListModule,
    MatToolbarModule,
    MatSidenavModule,
    MatButtonModule,
    FlexLayoutModule,
  ],
  providers: [
    DatePipe,
    GoogleAnalyticsService,
    { provide: AuthServiceConfig, useFactory: provideConfig },
    { provide: HTTP_INTERCEPTORS, useClass: CommonInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LogoutInterceptor, multi: true },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
